function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "white",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fillOpacity: 1
}, React.createElement("g", {
  transform: "translate(-1014.000000, -760.000000)",
  fill: "none"
}, React.createElement("path", {
  d: "M1146.6655,999.622085 L1110.83972,999.622085 L1110.83972,771 C1091.63414,771.762074 1054.70035,773.286221 1028.47735,775.191405 L1028.47735,784.336288 L1066.14982,784.336288 L1066.14982,999.622085 L1027,999.622085 L1027,1008.76697 L1146.6655,1008.76697 L1146.6655,999.622085 Z M1246.38675,812.533012 C1246.38675,791.194951 1243.06271,779.001773 1229.76654,779.001773 C1216.10104,779.001773 1212.777,791.194951 1212.777,812.533012 L1212.777,972.187435 C1212.777,993.14446 1218.68641,1004.57556 1229.76654,1004.57556 C1240.47735,1004.57556 1246.38675,993.14446 1246.38675,972.187435 L1246.38675,812.533012 Z M1229.76654,1012.57734 C1180.64459,1012.57734 1167.71777,925.319908 1167.34843,891.407632 C1166.97909,845.683215 1184.33797,771 1229.76654,771 C1275.19511,771 1292.554,845.683215 1292.18466,891.788668 C1291.81532,925.319908 1278.88849,1012.57734 1229.76654,1012.57734 Z",
  id: "path-1"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-59251244": "",
    width: "291px",
    height: "267px",
    viewBox: "0 0 291 267",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "number-10 number"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/10.4b445219.svg";
export { SvgComponent as ReactComponent };